import { Tabs } from "@mui/material";
import styled from "@emotion/styled";
import { grey } from "@mui/material/colors";

export const StyledTabs = styled(Tabs)(() => ({
  "& .MuiTab-root": {
    fontFamily: "Inter !important",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: grey[300],
    borderRadius: "10px",
    borderBottomRightRadius: "0px",
    borderBottomLeftRadius: "0px",
    marginRight: "0.5rem",
  },
  ".MuiTabs-scrollButtons": {
    backgroundColor: "black",
    borderRadius: "100px",
    color: "white",
    margin: "7px",
    marginBottom: "0px",
    height: "30px",
    width: "30x",
  },
  ".MuiTabs-scrollButtons.Mui-disabled ": {
    opacity: 0.3,
  },
  "& .Mui-selected": {
    color: "black !important",
    backgroundColor: "white !important",
  },
  "& .css-1aquho2-MuiTabs-indicator": {
    backgroundColor: "#161616",
  },
  "& .MuiTabs-flexContainer": {
    borderBottom: "0 none !important",
  },
}));

export const StyledTabBody = styled("div")(() => ({
  backgroundColor: "white",
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
  minHeight: "200px",
}));
